/*global Raven */
import { call, select, take } from 'redux-saga/effects';
import { postJSON } from '../util';

let tag;

export function sendError(exception, message) {
    Raven.captureException(exception, {level: 'error', message: message});
}

export function createTag() {
    if (tag) {
        return new Promise.resolve();
    }
    return new Promise((resolve) => {
        tag = document.createElement('script');
        tag.setAttribute('crossorigin', 'anonymous');
        tag.src = 'https://cdn.ravenjs.com/3.14.2/raven.min.js';
        tag.async = true;
        tag.onload = resolve;
        document.body.appendChild(tag);
    });
}

export function* loadRaven() {
    const key = yield select(state => state.sentry.key);
    Raven.config(key).install();
    Raven.setTransport((options) => postJSON('/api/sentry', options.data));
}

export function* root() {
    while(true) {
        const except = yield take('raven:error');

        yield call(createTag);
        yield call(loadRaven);

        const msg = except.payload.error.message || except.payload.message;
        sendError(except.payload.error, msg);
    }
}
